module.exports = __webpack_public_path__ + "static/media/Inventory.7558deb6.png";